/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum CalendarUserType {
  Talent = "Talent",
  HQ = "HQ",
  Client = "Client",
}

export const CalendarUserTypeDisplay: Record<CalendarUserType, string> = {
  [CalendarUserType.Talent]: "Talent",
  [CalendarUserType.HQ]: "HQ",
  [CalendarUserType.Client]: "Client",
};
